import React from 'react';
import { Redirect } from 'react-router-dom';
import Loadable from 'react-loadable';
import Loading from './components/Loading';
import Shopify from './containers/Shopify';
import NotFound from './containers/NotFound';
import LandingPage from './containers/CampaignLandingPage/LandingPage';
import SubmissionSuccess from './containers/CampaignLandingPage/SubmissionSuccess';

export default [
  {
    path: '/',
    exact: true,
    component: Loadable({ loader: () => import('./pages/SignIn'), loading: Loading })
  },
  {
    path: '/shopify',
    exact: true,
    component: Shopify
  },
  {
    path: '/not-found',
    exact: true,
    component: NotFound
  },
  {
    path: '/dashboard',
    exact: true,
    component: Loadable({ loader: () => import('./containers/Dashboard'), loading: Loading })
  },
  {
    path: '/c/:link*(/+)',
    exact: true,
    component: ({ location }) => <Redirect to={location.pathname.slice(0, -1)} />
  },
  {
    path: '/c/:link',
    exact: true,
    component: LandingPage
  },
  {
    path: '/c/:link/success',
    exact: true,
    component: SubmissionSuccess
  },
  {
    path: '/publishing',
    exact: true,
    component: Loadable({
      loader: () => import('./pages/Publishing/PublishingPage'),
      loading: Loading
    })
  },
  {
    path: '/compilation/:vcpId',
    exact: true,
    component: Loadable({ loader: () => import('./pages/CompilationPage'), loading: Loading })
  },
  {
    path: '/vc/:id',
    exact: true,
    component: Loadable({
      loader: () => import('./pages/CompilationLandingPage'),
      loading: Loading
    })
  },
  {
    path: '/v2/plugins/:pluginId',
    exact: true,
    component: Loadable({ loader: () => import('./pages/PluginPage'), loading: Loading })
  },
  {
    path: '/campaign',
    exact: true,
    component: Loadable({
      loader: () => import('./pages/Campaigns/CampaignsPage'),
      loading: Loading
    })
  },
  {
    path: '/campaign/:link',
    exact: true,
    component: Loadable({ loader: () => import('./containers/Campaign'), loading: Loading })
  },
  {
    path: '/campaigns/:link/edit',
    exact: true,
    component: Loadable({
      loader: () => import('./vp-ui/containers/CampaignEditPage/CampaignEditPage'),
      loading: Loading
    })
  },
  {
    path: '/media',
    exact: true,
    component: Loadable({
      loader: () => import('./pages/CampaignSubmissions/CampaignSubmissions'),
      loading: Loading
    })
  },
  {
    path: '/media/legacy',
    exact: true,
    component: Loadable({
      loader: () => import('./containers/MediaListPage/MediaListPage'),
      loading: Loading
    })
  },
  {
    path: '/media/:mediaId',
    exact: true,
    component: Loadable({
      loader: () => import('./containers/MediaDetailPage/MediaDetailPage'),
      loading: Loading
    })
  },
  {
    path: '/share/:pageType?/:mediaId/:fileName',
    exact: true,
    component: Loadable({
      loader: () => import('./containers/MediaShare/MediaShare'),
      loading: Loading
    })
  },
  {
    path: '/organization',
    exact: true,
    component: Loadable({ loader: () => import('./containers/Organization'), loading: Loading })
  },
  {
    path: '/insights',
    exact: true,
    component: Loadable({ loader: () => import('./containers/Insights'), loading: Loading })
  },
  {
    path: '/clients',
    exact: true,
    component: Loadable({ loader: () => import('./containers/Clients'), loading: Loading })
  },
  {
    path: '/users',
    exact: true,
    component: Loadable({ loader: () => import('./containers/Users'), loading: Loading })
  },
  {
    path: '/signup/:title?',
    exact: true,
    component: Loadable({ loader: () => import('./pages/SignUp'), loading: Loading })
  },
  {
    path: '/plan',
    exact: true,
    component: Loadable({ loader: () => import('./containers/SignupStepSecond'), loading: Loading })
  },
  {
    path: '/forgot/password',
    exact: true,
    component: Loadable({
      loader: () => import('./pages/ForgotPassword'),
      loading: Loading
    })
  },
  {
    path: '/reset/password/:token',
    exact: true,
    component: Loadable({
      loader: () => import('./pages/ResetPassword'),
      loading: Loading
    })
  },
  {
    path: '/videos',
    exact: true,
    component: Loadable({ loader: () => import('./containers/Videos'), loading: Loading })
  },
  {
    path: '/questions',
    exact: true,
    component: Loadable({ loader: () => import('./containers/Questions'), loading: Loading })
  },
  {
    path: '/videos/:uuid',
    exact: true,
    component: Loadable({ loader: () => import('./containers/Videos'), loading: Loading })
  },
  {
    path: '/campaign/videos/:filterId',
    exact: true,
    component: Loadable({ loader: () => import('./containers/Videos'), loading: Loading })
  },
  {
    path: '/plugin/:uuid',
    exact: true,
    component: Loadable({ loader: () => import('./containers/Plugin'), loading: Loading })
  },
  {
    path: '/billing',
    exact: true,
    component: Loadable({
      loader: () => import('./vp-ui/containers/BillingContainer'),
      loading: Loading
    })
  },
  {
    path: '/settings',
    exact: true,
    component: Loadable({ loader: () => import('./containers/Settings'), loading: Loading })
  },
  {
    path: '/admin-panel',
    exact: true,
    component: Loadable({ loader: () => import('./pages/AdminPanel/AdminPanel'), loading: Loading })
  },
  {
    path: '/change/password',
    exact: true,
    component: Loadable({ loader: () => import('./containers/ChangePassword'), loading: Loading })
  },
  {
    path: '/:id',
    exact: true,
    component: Loadable({ loader: () => import('./containers/Splash/Splash'), loading: Loading })
  },
  {
    path: '/view/:id',
    exact: true,
    component: Loadable({ loader: () => import('./containers/Splash/Splash'), loading: Loading })
  },
  {
    path: '/v/:fileName',
    exact: true,
    component: Loadable({ loader: () => import('./containers/Testimony'), loading: Loading })
  },
  {
    path: '*',
    exact: true,
    component: () => <Redirect to="/not-found" />
  }
];



// WEBPACK FOOTER //
// ./src/routes.js